//@flow

import React from "react";
import { Field } from "react-final-form";
import classnames from "classnames";
import type { FieldRenderProps } from "react-final-form";

import { RadioCustom, RadioGroupCustom } from "shared/formElements/Radio/RadioCustom";
import { Error } from "../shared/CommonComponents";
import { required } from "../../misc/validations";

import { textOrIcon } from "../../misc/helpers";

type propertyT = {
  label: string,
  size: any,
  value: string,
  labelPosition: string,
  iconName: string,
  iconWebReference: string,
};

type Props = {
  propertyTypeData: {
    buttons: {
      customs?: {
        width: number,
        height: number,
        direction: string,
        containerWidth: string,
      },
      elements: {
        [key: string]: propertyT,
      },
    },
  },
  inheritedStyles?: Object,
  inlineStyles?: Object,
};

const PropertyType = ({ propertyTypeData, inheritedStyles = null, inlineStyles }: Props) => {
  const {
    buttons: { customs, elements },
  } = propertyTypeData;
  const propertyTypeNames = Object.keys(propertyTypeData.buttons.elements);

  return (
    <>
      <Field name="propertyType" validate={required}>
        {({ input: { value, onChange }, meta }: FieldRenderProps) => {
          return (
            <RadioGroupCustom centered customs={customs} inheritedStyles={inheritedStyles}>
              {propertyTypeNames.map((type, index) => {
                const { iconName, label, labelPosition, iconWebReference } = elements?.[type];
                return (
                  <RadioCustom
                    key={"sof_property_button_" + index}
                    label={labelPosition === "outside" ? label : ""}
                    name="property"
                    value={type}
                    onChange={onChange}
                    selected={value === type}
                    inlineStyles={inlineStyles && inlineStyles}
                    customs={customs}
                    inheritedStyles={inheritedStyles}
                  >
                    {iconName && textOrIcon(iconName)}
                    {iconWebReference && <i className={classnames(iconWebReference)} />}
                    {labelPosition === "inside" ? label : ""}
                  </RadioCustom>
                );
              })}
            </RadioGroupCustom>
          );
        }}
      </Field>
      <Error name="propertyType" />
    </>
  );
};

export default PropertyType;
